import { FC, useReducer, useEffect } from 'react';

import IFramedPromoPartnershipLogin from './IFramedPromoPartnershipLogin';
import IFramedPromoPartnershipAuthError from './IFramedPromoPartnershipAuthError';
import IFramedPromoPartnershipFlow from './IFramedPromoPartnershipFlow';
import IFramedPromoPartnershipAddToWhitelist from './IFramedPromoPartnershipAddToWhitelist';
import IFramedPromoPartnershipNoPromoToken from './IFramedPromoPartnershipNoPromoToken';
import IFramedPromoPartnershipPromoCode from './IFramedPromoPartnershipPromoCode';
import IFramedPromoPartnershipNoPromoCode from './IFramedPromoPartnershipNoPromoCode';
import IFramedPromoPartnershipFormSubmitted from './IFramedPromoPartnershipFormSubmitted';

import {
    reducer,
    initialState,
    STEP_LOGIN,
    STEP_AUTH_ERROR,
    STEP_FLOW,
    STEP_NO_PROMO_TOKEN,
    STEP_PROMO_TOKEN_ADD_USER_TO_WHITELIST,
    STEP_PROMO_TOKEN_PROMO_CODE,
    STEP_PROMO_TOKEN_NO_PROMO_CODE,
    STEP_FORM_SUBMITTED,
} from './reducer';

import styles from './styles/IFramedPromoPartnershipWrapper.scss';

const IFramedPromoPartnershipWrapper: FC = () => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const { step, promoCode } = state;

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [step]);

    let content = null;

    switch (step) {
        case STEP_LOGIN:
            content = <IFramedPromoPartnershipLogin dispatch={dispatch} />;
            break;

        case STEP_AUTH_ERROR:
            content = <IFramedPromoPartnershipAuthError dispatch={dispatch} />;
            break;

        case STEP_FLOW:
            content = <IFramedPromoPartnershipFlow dispatch={dispatch} />;
            break;

        case STEP_NO_PROMO_TOKEN:
            content = <IFramedPromoPartnershipNoPromoToken state={state} dispatch={dispatch} />;
            break;

        case STEP_PROMO_TOKEN_ADD_USER_TO_WHITELIST:
            content = <IFramedPromoPartnershipAddToWhitelist state={state} dispatch={dispatch} />;
            break;

        case STEP_PROMO_TOKEN_PROMO_CODE:
            content = <IFramedPromoPartnershipPromoCode state={state} dispatch={dispatch} />;
            break;

        case STEP_PROMO_TOKEN_NO_PROMO_CODE:
            content = <IFramedPromoPartnershipNoPromoCode />;
            break;

        case STEP_FORM_SUBMITTED:
            content = <IFramedPromoPartnershipFormSubmitted promoCode={promoCode} />;
            break;
    }

    return <section className={styles.wrapper}>{content}</section>;
};

export default IFramedPromoPartnershipWrapper;
